import React from 'react';
// import Tilty from 'react-tilty';
import { useSpring, animated } from 'react-spring';

const BcrumbBannerOne = ({ title, paragraph, tituloabranco, mainThumb }) => {

    const [springProps, setSpring] = useSpring(() => ({
        scale: 1,
    }));

    return (
        <div className="breadcrum-area breadcrumb-banner" style={{ backgroundImage: `url(${process.env.PUBLIC_URL + mainThumb})`, backgroundSize: "100% 100%" }}>
            <div className="container">

                <div className="section-heading heading-left" style={{marginLeft:'10%'}}>
                    <animated.div
                        style={{
                            transform: springProps.scale.interpolate((s) => `scale(${s})`),
                            cursor: 'pointer',
                        }}
                        onMouseEnter={() => setSpring({ scale: 1.2 })}
                        onMouseLeave={() => setSpring({ scale: 1 })}
                    >
                        <p className={tituloabranco === 'yes' ? "title h2 LightTitle" : "title h2 DarkTitle"} dangerouslySetInnerHTML={{ __html: title }}></p>
                        <p className={tituloabranco === 'yes' ? "LightSubtitle" : "DarkSubtitle"} dangerouslySetInnerHTML={{__html: paragraph}}></p>
                    </animated.div>
                </div>

            </div>

            <ul className="shape-group-8 list-unstyled">
                <li className="shape shape-1">
                    <img src={process.env.PUBLIC_URL + "/images/others/bubble-9.webp"} alt="Bubble" style={{opacity:"70%"}}/>
                </li>
                {/* <li className="shape shape-2">
                    <img src={process.env.PUBLIC_URL + "/images/others/bubble-21.png"} style={{opacity:"20%"}} alt="Bubble" />
                </li> */}
                <li className="shape shape-3">
                    <img src={process.env.PUBLIC_URL + "/images/others/line-4.webp"} alt="Line" />
                </li>
            </ul>
        </div >
    )
}

export default BcrumbBannerOne;